import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-card',
  host: {
    class: 'block w-full',
  },
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './card.html',
  styleUrl: './card.css',
})
export class Card {
  styleClass = input('');

  title = input('');
  subtitle = input('');
}
